import { render, staticRenderFns } from "./RuleGroupModal.vue?vue&type=template&id=0f794ff6&scoped=true&"
import script from "./RuleGroupModal.vue?vue&type=script&lang=js&"
export * from "./RuleGroupModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f794ff6",
  null
  
)

export default component.exports